import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import {
  FormClassRetire,
  RetireFlowReason,
  RetireReason,
} from "../../assets/data/Constants";

const stepper = [
  "退職者の基本情報登録",
  "添付書類の登録",
  "従業状況の登録確認",
  "退職した月以前6ヶ月の本俸月額登録",
  "退職手当金請求の順番登録",
  "源泉徴収票の登録",
  "登録内容の確認",
  "機構へ提出",
];
const infoHeadTitleList: any[] = [
  {
    headTitle: "順番",
    helpText: "育児休業が登録されている順番です。",
  },
  {
    headTitle: "出生日",
    helpText: "育児休業の対象となる子の出生日です。",
  },
  {
    headTitle: "育児休業開始日",
    helpText:
      "育児休業の開始日です。女性の場合、育児休業開始日は出産日の翌日から57日目となります。",
  },
  {
    headTitle: "育児休業終了日",
    helpText: (
      <>
        育児休業終了日です。育児休業終了日は原則として、子が満1歳に達する日までの期間（誕生日の前日）となります。
        <br />
        ※要件を満たせば、1歳2か月まで、1歳6か月まで、2歳まで取得することが可能です。
      </>
    ),
  },
  {
    headTitle: "パパ・ママ育休プラス",
    helpText:
      "パパ・ママ育休プラスの利用有無です。パパ・ママ育休プラスとは、通常、育児休業終了日は子が満1歳に達する日までの期間（誕生日の前日）となりますが、夫婦ともに育児休業を取得することで、1歳2か月まで延長することができる制度です。",
  },
  {
    headTitle: "半年延長の理由",
    helpText: (
      <>
        次の条件のいずれかに当てはまる場合、子が１歳6か月（又は2歳）に達するまでの間、育児休業を取得することができます。
        <br />
        １．保育所等に入所を希望しているが、1歳（又は1歳6か月）に達する日後の期間について、入所できない場合
        <br />
        ２．この養育を行っている配偶者であって、1歳（又は1歳6か月）に達する日後の期間について、子の養育を行う予定であった者が、死亡・負傷・疾病等、離婚等により、子を養育することができなくなった場合
      </>
    ),
  },
  {
    headTitle: "産後パパ育休",
    helpText:
      "当該育児休業申請が産後パパ育休にあたる場合は「有」となります。産後パパ育休とは、産後8週間以内に4週間（28日）を限度として2回に分けて取得できる休業のことで、1歳までの育児休業とは別に取得できる制度です。",
  },
];

const headListWorkingDayNum: any[] = [
  {
    headTitle: "対象年月",
  },
  {
    headTitle: "出勤日数",
  },
];

const infoHeadTitleTwoList: any[] = [
  {
    headTitle: "年月",
    helpText:
      "退職手当金の算定となる退職月前６か月間の年月です。退職日が月末でない場合は、退職月の前月から6か月間を遡ります。また、「ならない月」がある場合は、当該月を除きます。",
  },
  {
    headTitle: "俸給表の額",
    helpText: (
      <>
        俸給表の額とは、共済契約者が給与規程で定める本俸額です。ただし、給与規程で本俸が定められていない職員は、雇用契約書で定める労働条件をもとに計算した額となります。日給・時給の場合の記載方法は、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給表の額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
        <br />
        【注意点】実際の支給された額を記載するのではなく、給与規程や雇用契約書等に定められた額を記載いただくものです。"
      </>
    ),
  },
  {
    headTitle: "手当名",
    helpText: "退職手当金の算定に使用する手当の名称です。",
  },
  {
    headTitle: "俸給表の調整額",
    helpText: (
      <>
        「俸給の調整額」対象手当として当機構が認めた手当の金額です。
        登録されている手当以外の金額は計上することができません。未登録の場合は登録申請が必要です。俸給の調整額については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給の調整額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
    helpicon: true,
    helpText: "被共済職員の番号です。",
  },
  {
    title: "退職者名カナ",
    keyword: "bNameKana",
    type: "text",
  },
  {
    title: "退職者名",
    keyword: "bNameKanji",
    type: "text",
    helpicon: true,
    helpText: (
      <>
        退職する被共済職員の氏名です。
        <br />
        外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字は、正しく表示されない場合があります。
      </>
    ),
  },
  {
    title: "退職者名カナ（新）",
    keyword: "staffNameKana",
    type: "text",
    showLine: true,
  },
  {
    title: "退職者名（新）",
    keyword: "staffNameKanji",
    type: "text",
    showLine: true,
  },
  {
    title: "退職者生年月日",
    keyword: "birthday",
    type: "text",
    helpicon: true,
    helpText: "退職者の生年月日です。",
  },
  {
    title: "退職者加入年月日",
    keyword: "firstJoinDate",
    type: "text",
    helpicon: true,
    helpText: "退職者が当制度に加入された年月日です。",
  },
  {
    title: "退職年月日",
    keyword: "retireDate",
    type: "text",
    helpicon: true,
    helpText: "退職者の退職年月日です。",
  },
  {
    title: "退職理由",
    keyword: "retireReason",
    type: "text",
    helpicon: true,
    helpText: (
      <>
        「普通退職」「業務上の傷病又は死亡による退職」「犯罪等による退職」の3区分があります。
        <br />
        ・「普通退職」：一身上の都合による退職、定年退職、雇用期間満了による退職などが該当します。以下の「業務上の傷病又は死亡による退職」、「犯罪等による退職」に該当しない場合は、「普通退職」となります。
        <br />
        ・「業務上の傷病又は死亡による退職」：業務災害（通勤災害）に起因する傷病・死亡による退職が該当します。なお、業務災害（通勤災害）に起因する傷病・死亡による退職であることを証する添付書類の提出が必要となります。添付書類を機構にて確認した結果、退職理由を「普通退職」とする場合があります。
        <br />
        ・「犯罪等による退職」：犯罪行為、またはこれに準ずべき重大な非行行為による退職が該当します。なお、犯罪行為、またはこれに準ずべき重大な非行行為による退職であることを証する添付書類の提出が必要となります。添付書類を機構にて確認した結果、退職理由を「普通退職」とする場合があります（単なる就業規則違反に該当するもの、罰金刑が確定しているものは退職理由「①普通退職」として届け出てください。）。「犯罪等による退職」であると機構が認定した場合は退職手当金が不支給となるため、審査に相応の時間を必要とします。
      </>
    ),
  },
  {
    title: "退職手続きの理由",
    keyword: "retireProcedureReason",
    type: "text",
    helpicon: true,
    helpText:
      "「普通退職」における「死亡による退職」とは、業務災害（通勤災害）に起因する死亡以外によって退職する場合が該当します。また、「普通退職」における「法人（業務上の）都合」とは、共済契約者間で施設運営上の理由により人材を融通することを事前に合意した転職のみが対象となります。それ以外のケースについては、自己都合による退職となります。",
  },
  {
    title: "退職者郵便番号",
    keyword: "zipcode",
    type: "text",
    helpicon: true,
    helpText: "退職者の居住場所の郵便番号です。",
  },
  {
    title: "退職者住所",
    keyword: "address",
    type: "text",
    helpicon: true,
    helpText: "退職者の居住場所の住所です。",
  },
  {
    title: "退職者電話番号",
    keyword: "tel",
    type: "text",
    helpicon: true,
    helpText: "退職者に連絡が取れる電話番号（携帯電話可）です。",
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: "育休状況",
  },
  {
    title: "ならない月",
    keyword: "exclusionMonth",
    type: "checkboxGroup",
    checkBoxList: [
      { label: "無", key: "none", disabled: true },
      { label: "4月", key: "apr", disabled: true },
      { label: "5月", key: "may", disabled: true },
      { label: "6月", key: "jun", disabled: true },
      { label: "7月", key: "jul", disabled: true },
      { label: "8月", key: "aug", disabled: true },
      { label: "9月", key: "sep", disabled: true },
      { label: "10月", key: "oct", disabled: true },
      { label: "11月", key: "nov", disabled: true },
      { label: "12月", key: "dec", disabled: true },
      { label: "1月", key: "jan", disabled: true },
      { label: "2月", key: "feb", disabled: true },
      { label: "3月", key: "mar", disabled: true },
    ],
    helpicon: true,
    helpText: (
      <>
        退職年度におけるならない月です。ならない月とは１０日を超えて業務に従事していない月（育児休業期間は含みません）のことで、退職手当金の算定基礎とならない月になります。詳しくは
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫「なる月」「ならない月」について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    keyword: "childcareLeaveInfo",
    type: "node",
  },
  {
    keyword: "childcareActiveListList",
    type: "node",
  },
  {
    keyword: "salaryInfo",
    type: "node",
  },
  {
    keyword: "lineTitleFile",
    type: "lineTitle",
    lineTitle: "添付書類",
    showLine: true,
  },
  {
    title: "退職理由",
    keyword: "retireReasonForFile",
    type: "text",
    helpicon: true,
    helpText:
      "退職理由が「普通退職」以外の場合は、指定する添付書類が必要となります。",
  },
  {
    title: "現認証明書（傷病）",
    id: RetireFlowReason["傷病による退職"],
    keyword: FormClassRetire["現認証明書（事務取扱要領　様式10-2号）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title:
      "労働者災害補償保険の「障害補償給付又は傷病補償年金の支給決定通知書」（写）",
    id: RetireFlowReason["傷病による退職"],
    keyword:
      FormClassRetire["障害補償給付又は傷病補償年金の支給決定通知書（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "障害厚生年金の受給を証する書類等",
    id: RetireFlowReason["傷病による退職"],
    keyword: FormClassRetire["障害厚生年金の受給を証する書類又は医師の診断書"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "現認証明書（死亡）",
    id: RetireFlowReason["死亡による退職"],
    keyword: FormClassRetire["現認証明書（事務取扱要領　様式10-3号）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "「死亡診断書又は死体検案書」（写）",
    id: RetireFlowReason["死亡による退職"],
    keyword: FormClassRetire["死亡診断書（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title:
      "「葬祭料(葬祭給付)の支給決定通知書」(写)又は「第三者行為災害届」(写)(労基署受理のもの)",
    id: RetireFlowReason["死亡による退職"],
    keyword:
      FormClassRetire["葬祭料の支給決定通知書（写）又は第三者行為災害届（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "生計維持に関する調査書（戸籍上の配偶者が請求者となる場合は不要）",
    id: RetireFlowReason["死亡による退職"],
    keyword: FormClassRetire["生計維持に関する調査書（様式11号）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "問題行為の概要がわかる書類",
    id: RetireReason["犯罪等による退職"],
    keyword: FormClassRetire["問題行動の概要が分かる書類"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "懲戒処分・解雇の辞令（写）",
    id: RetireReason["犯罪等による退職"],
    keyword: FormClassRetire["懲戒処分・解雇の辞令（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "解雇等処分について審議された議事録（写）",
    id: RetireReason["犯罪等による退職"],
    keyword: FormClassRetire["解雇処分について審議された議事録（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "就業規則（写）",
    id: RetireReason["犯罪等による退職"],
    keyword: FormClassRetire["就業規則（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "処分対象者の答弁が含まれる記録（写）、自認書（写）等",
    id: RetireReason["犯罪等による退職"],
    keyword: FormClassRetire["事情聴取の調書等の記録書面（写）、自認書（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "判決書（写）",
    id: RetireReason["犯罪等による退職"],
    keyword: FormClassRetire["判決書（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "新聞記事（写）",
    id: RetireReason["犯罪等による退職"],
    keyword: FormClassRetire["新聞記事（写）"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "その他当機構が求めた書類",
    id: RetireReason["犯罪等による退職"],
    keyword: FormClassRetire["その他機構が求めた書類"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "賃金台帳",
    id: "4",
    keyword: FormClassRetire["賃金台帳"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "雇用契約書",
    id: "5",
    keyword: FormClassRetire["雇用契約書"],
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: "退職手当金支払いの順番",
  },
  {
    title: "福祉医療機構以外からの退職金受け取りの有無",
    keyword: "prefectureRetirementJoinFlg",
    type: "text",
  },
  {
    title: "退職金請求の順番",
    keyword: "retirementInvoiceOrder",
    type: "text",
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: "源泉徴収票",
  },
  {
    title: "退職所得の源泉徴収票（１枚目）",
    keyword: "page1Withholding",
    type: "downloadLink",
    downloadBase64: true,
    helpicon: true,
    helpText:
      "他の制度等から支給された退職金にかかる退職所得の源泉徴収票です。",
  },
  {
    title: "区分（１枚目）",
    keyword: "page1Kbn",
    type: "text",
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている区分です。",
  },
  {
    title: "支払金額（１枚目）",
    keyword: "page1PaymentAmt",
    type: "text",
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている支払金額です。",
  },
  {
    title: "源泉徴収額（１枚目）",
    keyword: "page1WithholdingAmt",
    type: "text",
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額です。",
  },
  {
    title: "特別徴収税額：市町村民税（１枚目）",
    keyword: "page1ScAmtCity",
    type: "text",
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額のうちの市町村民税額です。",
  },
  {
    title: "特別徴収税額：都道府県税（１枚目）",
    keyword: "page1ScAmtPrefecture",
    type: "text",
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額のうちの都道府県民税額です。",
  },
  {
    title: "勤続年数（１枚目）",
    keyword: "page1LengthOfService",
    type: "text",
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載された勤続年数です。",
  },
  {
    title: "就労年月日（１枚目）",
    keyword: "page1EmployedDate",
    type: "text",
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている就労年月日です。",
  },
  {
    title: "退職年月日（１枚目）",
    keyword: "page1RetiredDate",
    type: "text",
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている退職年月日です。",
  },
  {
    title: "控除期間（年）（１枚目）",
    keyword: "page1DeductionPeriodYear",
    type: "text",
  },
  {
    title: "控除期間（月）（１枚目）",
    keyword: "page1DeductionPeriodMonth",
    type: "text",
  },
  // 二枚目
  {
    title: "退職所得の源泉徴収票（２枚目）",
    id: "page2",
    keyword: "page2Withholding",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    helpicon: true,
    helpText:
      "他の制度等から支給された退職金にかかる退職所得の源泉徴収票です。",
  },
  {
    title: "区分（２枚目）",
    id: "page2",
    keyword: "page2Kbn",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている区分です。",
  },
  {
    title: "支払金額（２枚目）",
    id: "page2",
    keyword: "page2PaymentAmt",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている支払金額です。",
  },
  {
    title: "源泉徴収額（２枚目）",
    id: "page2",
    keyword: "page2WithholdingAmt",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額です。",
  },
  {
    title: "特別徴収税額：市町村民税（２枚目）",
    id: "page2",
    keyword: "page2ScAmtCity",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額のうちの市町村民税額です。",
  },
  {
    title: "特別徴収税額：都道府県税（２枚目）",
    id: "page2",
    keyword: "page2ScAmtPrefecture",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額のうちの都道府県民税額です。",
  },
  {
    title: "勤続年数（２枚目）",
    id: "page2",
    keyword: "page2LengthOfService",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載された勤続年数です。",
  },
  {
    title: "就労年月日（２枚目）",
    id: "page2",
    keyword: "page2EmployedDate",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている就労年月日です。",
  },
  {
    title: "退職年月日（２枚目）",
    id: "page2",
    keyword: "page2RetiredDate",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている退職年月日です。",
  },
  {
    title: "控除期間（年）（２枚目）",
    id: "page2",
    keyword: "page2DeductionPeriodYear",
    type: "text",
  },
  {
    title: "控除期間（月）（２枚目）",
    id: "page2",
    keyword: "page2DeductionPeriodMonth",
    type: "text",
    showLine: false,
  },
  // 三枚目
  {
    title: "退職所得の源泉徴収票（３枚目）",
    id: "page3",
    keyword: "page3Withholding",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
    helpicon: true,
    helpText:
      "他の制度等から支給された退職金にかかる退職所得の源泉徴収票です。",
  },
  {
    title: "区分（３枚目）",
    id: "page3",
    keyword: "page3Kbn",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている区分です。",
  },

  {
    title: "支払金額（３枚目）",
    id: "page3",
    keyword: "page3PaymentAmt",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている支払金額です。",
  },
  {
    title: "源泉徴収額（３枚目）",
    id: "page3",
    keyword: "page3WithholdingAmt",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額です。",
  },
  {
    title: "特別徴収税額：市町村民税（３枚目）",
    id: "page3",
    keyword: "page3ScAmtCity",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額のうちの市町村民税額です。",
  },
  {
    title: "特別徴収税額：都道府県税（３枚目）",
    id: "page3",
    keyword: "page3ScAmtPrefecture",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額のうちの都道府県民税額です。",
  },

  {
    title: "勤続年数（３枚目）",
    id: "page3",
    keyword: "page3LengthOfService",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載された勤続年数です。",
  },
  {
    title: "就労年月日（３枚目）",
    id: "page3",
    keyword: "page3EmployedDate",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている就労年月日です。",
  },
  {
    title: "退職年月日（３枚目）",
    id: "page3",
    keyword: "page3RetiredDate",
    type: "text",
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載されている退職年月日です。",
  },
  {
    title: "控除期間（年）（３枚目）",
    id: "page3",
    keyword: "page3DeductionPeriodYear",
    type: "text",
  },
  {
    title: "控除期間（月）（３枚目）",
    id: "page3",
    keyword: "page3DeductionPeriodMonth",
    type: "text",
    showLine: false,
  },
];

const spaceArea = `　`;
const context = (
  <>
    機構へ提出後、
    <span className="redText">
      共済契約者が退職者に代わって退職金請求または合算申出を行う場合
    </span>
    は、チェックをつけてください。
  </>
);
const conTop = `　登録内容を確認し、誤りがなければ、「機構へ提出する」ボタンを押してください。`;
const conMid = `　なお、退職日前に「機構へ提出する」ボタンを押した場合は、退職日以後に自動で提出されます。提出状況についてはメニューの「退職者状況一覧」から随時確認できます。\\n
　※退職しなかった場合は、提出される前に取下げを行ってください。`;
export {
  stepper,
  conTop,
  spaceArea,
  conMid,
  context,
  fakeTableList,
  infoHeadTitleList,
  infoHeadTitleTwoList,
  headListWorkingDayNum,
};
